import { toast } from "sonner";
import i18next from "i18next";
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

/**
 * SoA list + justification updates.
 * List load errors: caller shows inline UI (no duplicate toast).
 * Justification save: toast owner here (mutation).
 */
export class SoaIntegration {
    /**
     * @param {import('@repo/sdk').ControlService} controlService
     */
    constructor(controlService) {
        this.service = controlService;
    }

    async fetchStats() {
        try {
            const response = await this.service.getSoaStats();
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: error.message, data: null };
        }
    }

    async fetchSoaList(params = {}) {
        try {
            const res = await this.service.getSoaList(params);
            return {
                success: true,
                data: res.data || [],
                summary: res.summary || {},
                meta: res.meta || {},
                uniqueValues: res.uniqueValues || {},
            };
        } catch (error) {
            const message =
                error.message || i18next.t("ismsControlsSoa:errors.listLoad", {
                    defaultValue: "Could not load SoA list",
                });
            return { success: false, error: message };
        }
    }

    async saveJustification(controlId, comment, changeReason) {
        try {
            await this.service.createEvaluationVersion(controlId, {
                evaluation_payload: { comment: String(comment ?? "") },
                change_reason: changeReason?.trim() || undefined,
            });
            toast.success(
                i18next.t("ismsControlsSoa:messages.justificationSaved", {
                    defaultValue: "Justification saved",
                })
            );
            return { success: true };
        } catch (error) {
            const message =
                getIntegrationErrorMessage(error) || i18next.t("ismsControlsSoa:messages.justificationError", {
                    defaultValue: "Could not save justification",
                });
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
